import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';

import ErrorList from '../../../types/UI/ErrorList';
import fieldStyles from '../../BaseField.module.css';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import HiddenField from '../../HiddenField/HiddenField';
import Inline from '../../Inline/Inline';
import Label from '../../Label/Label';
import Row from '../../Row/Row';
import Stack from '../../Stack/Stack';

type WrappedChildrenProps = {
    inline?: boolean;
    noWrap?: boolean;
    inlineAlignment?: ComponentProps<typeof Inline>['horizontal'];
    children?: ReactNode;
};

const WrappedChildren = ({
    children,
    noWrap,
    inlineAlignment,
    inline,
}: WrappedChildrenProps) => {
    if (!inline) {
        return <Stack space="xsmall">{children}</Stack>;
    }

    if (noWrap) {
        return (
            <Row space="xsmall" horizontal={inlineAlignment} vertical="bottom">
                {children}
            </Row>
        );
    }
    return (
        <Inline space="xsmall" vertical="bottom" horizontal={inlineAlignment}>
            {children}
        </Inline>
    );
};

type ListRendererProps = {
    className?: string;
    value?: string;
    label?: ReactNode;
    errors?: ErrorList;
    name?: string;
    inline?: boolean;
    noWrap?: boolean;
    inlineAlignment?: ComponentProps<typeof Inline>['horizontal'];
    children?: ReactNode;
};

const ListRenderer = ({
    className,
    value,
    label,
    name,
    inline,
    noWrap,
    inlineAlignment,
    children,
    errors,
}: ListRendererProps) => {
    const classes = classNames(className, {
        [fieldStyles.Field]: true,
        [fieldStyles['has-errors']]: errors && errors.length,
    });

    return (
        <div className={classes}>
            <HiddenField name={name} value={value ?? ''} />
            <Stack space="small">
                {label && <Label>{label}</Label>}

                <WrappedChildren
                    inline={inline}
                    noWrap={noWrap}
                    inlineAlignment={inlineAlignment}
                >
                    {children}
                </WrappedChildren>

                <ErrorMessage className={fieldStyles.Errors}>
                    {errors}
                </ErrorMessage>
            </Stack>
        </div>
    );
};

export default ListRenderer;
